import { Forwarder, UsCustomsBroker } from '@xbcb/api-gateway-client';

export const validateAgentForDeliveryOrder = (
  agent: Forwarder | UsCustomsBroker,
): string[] => {
  const errors: string[] = [];
  // 9/14/2021: As per the feedback from business, these checks are not needed, so commenting them out.
  //            add back/modify if needed again
  // if (!agent.addresses?.mailing || !agent.addresses?.physical) {
  //   errors.push(
  //     `The agent ${agent.name} doesn't have either mailing or physical address`,
  //   );
  // }
  // if (!agent.email) {
  //   errors.push(`The agent ${agent.name} doesn't have support email`);
  // }

  // if (!agent.phone?.number) {
  //   errors.push(`The agent ${agent.name} doesn't have support phone number`);
  // }
  return errors;
};
